<template>
  <div class="freebets-round text-black animation-slide md:px-3">
    <div class="content-box-style">
      <Filters
        :options="options"
        :showActionButton="true"
        :search="search"
        :resetFilter="resetFilter"
        :resetPagination="resetPagination"
      />
      <div
        v-if="isLoading"
        class="flex-grow flex flex-col items-center justify-center p-20"
      >
        <Loader />
      </div>

      <div
        v-else
        class="table-container-custom shadow-sm rounded-2xl overflow-hidden border border-1 mb-3 mt-3"
      >
        <DataTable
          v-model:selection="campaignsSelected"
          :value="tableData"
          :loading="isLoading"
          :lazy="true"
          :paginator="true"
          :rows="selectedLimit"
          :totalRecords="totalElements"
          :first="(currentPage - 1) * selectedLimit"
          dataKey="_id"
          @page="onPage"
          @sort="onSort"
          :sortField="sortField"
          :sortOrder="sortOrder === 'desc' ? -1 : 1"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[15, 25, 50, 100]"
          :currentPageReportTemplate="`Mostrando da {first} a {last} di {totalRecords} elementi`"
          showCurrentPageReport
          stripedRows
          removableSort
          scrollable
          scrollHeight="flex"
          class="freebets-datatable p-datatable-sm"
        >
          <template #empty>
          <div class="text-center py-4 text-muted">No data found.</div>
          </template>

          <Column
            v-for="col in columns"
            :key="col.slug"
            :field="col.slug"
            :header="col.label"
            :sortable="col.sortable"
          >
            <template #body="slotProps">
              <span v-if="col.type === 'date'">
                {{
                  slotProps.data[col.slug]
                    ? formatDate(slotProps.data[col.slug])
                    : "-"
                }}
              </span>

              <div v-else-if="col.type === 'boolean'" class="text-start">
                <i
                  class="pi"
                  :class="
                    slotProps.data[col.slug]
                      ? 'pi-check-circle text-green-500'
                      : 'pi-times-circle text-red-500'
                  "
                ></i>
              </div>

              <div v-else-if="col.type === 'action_button'" class="text-center">
                <button
                  @click="showTask(slotProps.data)"
                  class="p-2 hover:bg-gray-100 rounded-full transition-colors"
                  title="Visualizza Task"
                >
                  <i class="pi pi-eye text-blue-600"></i>
                </button>
              </div>

              <span v-else>
                {{ slotProps.data[col.slug] }}
              </span>
            </template>
          </Column>
        </DataTable>
      </div>
      <TaskProgress
        v-if="tasksData && visible"
        :tasksData="tasksData"
        :visible="visible"
        :showTask="showTask"
      />
    </div>
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Filters from "../table/Filters.vue";
import TaskProgress from "./TaskProgress.vue";
import { getFetch } from "@/api/axiosClient.js";
import Loader from "../Loader.vue";

export default {
  name: "ChallengePlayerActive",
  components: {
    Filters,
    TaskProgress,
    DataTable,
    Column,
    Loader,
  },
  props: {
    campaignId: { type: String, required: true },
    challengeMode: { type: String, required: true },
    skinFilt: { required: true },
  },
  data() {
    return {
      tableData: [],
      campaignsSelected: null,
      isLoading: false,
      totalElements: 0,
      totalPages: 1,

      currentPage: 1,
      selectedLimit: 15,
      sortField: null,
      sortOrder: "desc",

      player_id: "",
      skin_id: 0,
      is_closed: "All",
      is_completed: "All",
      points_min: null,
      points_max: null,

      columns: [],
      base_columns: [
        {
          slug: "created_at",
          label: "Registered At",
          type: "date",
          sortable: true,
        },
        { slug: "end_at", label: "End At", type: "date" },
        {
          slug: "reached_at",
          label: "Reached At",
          type: "date",
          sortable: true,
        },
      ],
      player_column: [{ slug: "player_id", type: "text", label: "Player ID" }],
      action_column: [
        { type: "action_button", label: "Actions", slug: "actions" },
      ],
      advanced_column: [],

      options: [
        {
          label: "Player ID",
          type: "text",
          placeholder: "Search for Player ID",
          property: "player_id",
        },
        {
          label: "Campaign ID",
          type: "text",
          property: "campaignId",
          disabled: true,
        },
      ],

      tasksData: null,
      visible: false,
    };
  },
  async mounted() {
    this.skin_id = this.skinFilt;
    this.initConfiguration();
    await this.search();
  },
  methods: {
    initConfiguration() {
      if (this.challengeMode !== "tournament") {
        this.options.push({
          label: "Is Completed",
          type: "select",
          property: "is_completed",
          options: ["All", "True", "False"],
        });
        this.advanced_column.push({
          slug: "is_completed",
          label: "Completed",
          type: "boolean",
        });
      } else {
        this.options.push(
          { label: "Min Points", type: "number", property: "points_min" },
          { label: "Max Points", type: "number", property: "points_max" },
        );
        this.sortField = "points";
      }
    },

    async onPage(event) {
      this.currentPage = event.page + 1;
      this.selectedLimit = event.rows;
      await this.search();
    },

    async onSort(event) {
      this.sortField = event.sortField;
      this.sortOrder = event.sortOrder === -1 ? "desc" : "asc";
      await this.search();
    },

    async search() {
      this.isLoading = true;
      this.generateColumns();

      try {
        const params = {
          skin_id: this.skin_id,
          page: this.currentPage,
          limit: this.selectedLimit,
          campaign_id: this.campaignId,
          sortField:
            this.sortField ||
            (this.challengeMode === "tournament" ? "points" : "created_at"),
          sortOrder: this.sortOrder,
        };

        if (this.player_id) params.player_id = this.player_id.trim();
        if (this.is_closed !== "All")
          params.is_closed = this.is_closed === "True";
        if (this.is_completed !== "All")
          params.is_completed = this.is_completed === "True";

        if (this.challengeMode === "tournament") {
          if (this.points_min) params.points_min = Number(this.points_min);
          if (this.points_max) params.points_max = Number(this.points_max);
        }

        const response = await getFetch(`challenges/players`, params);

        this.tableData = response.data;
        this.totalPages = response.totalPages;
        this.totalElements = response.totalItems;

        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (error) {
        console.error("Errore fetch dati:", error);
      } finally {
        this.isLoading = false;
      }
    },

    generateColumns() {
      const excludedSlugs = ["updated_at", "multiplier"];

      let dynamicCols = [];

      if (this.challengeMode === "tournament") {
        dynamicCols.push({
          slug: "position",
          label: "Pos",
          type: "int",
          sortable: false,
        });
      }

      dynamicCols = [...dynamicCols, ...this.player_column];

      if (this.challengeMode === "tournament") {
        dynamicCols.push({
          slug: "points",
          label: "Points",
          type: "int",
          sortable: true,
        });
      }

      let merged = [
        ...dynamicCols,
        ...this.base_columns,
        ...this.advanced_column,
        ...this.action_column,
      ];

      this.columns = merged.filter((col) => !excludedSlugs.includes(col.slug));
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleString([], {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    showTask(data, val = true) {
      this.tasksData = data;
      this.visible = val;
    },

    async resetPagination() {
      this.currentPage = 1;
    },

    async resetFilter() {
      this.currentPage = 1;
      this.selectedLimit = 15;
      this.player_id = "";
      this.is_closed = "All";
      this.is_completed = "All";
      this.points_max = null;
      this.points_min = null;
      this.sortField =
        this.challengeMode === "tournament" ? "points" : "created_at";
      this.sortOrder = "desc";
      await this.search();
    },
  },
};
</script>
